import { indexes } from '@mab-common/utils'

import { useSearch } from '~/services/query'
import RecordTypes = indexes.RecordTypes

export interface IArtistListItem {
  _id: string
  name: string
  slug: string
  totalArtworks: number
}

const useHooks = (fallbackData?: any, querySlug?: string) => {
  const { data, isLoading } = useSearch(10000, RecordTypes.ARTIST, querySlug)
  return {
    isLoading,
    data: data?.[0]?.hits || fallbackData,
  }
}

export default useHooks
